/**
 * Block 10 (2026-05-27): Reusable CSS-grid layout для widgets.
 *
 * Responsive: auto-fit columns з min-width 320px → fluid layout.
 * Mobile: single column. Desktop: 2-3 widgets per row.
 *
 * Не використовує external libs (react-grid-layout etc.) — yagni
 * до 3+ widgets з sortable/resizable вимогою.
 */
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function WidgetGrid({ children }: Props) {
  return (
    <div
      data-testid="widget-grid"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
        gap: 16,
        marginTop: '1rem',
      }}
    >
      {children}
    </div>
  );
}
